module.exports = __webpack_public_path__ + "static/case-loews-v2-2c2a3b10d8cbc5a3ae281c805cdf1319.jpg";